export default __webpack_public_path__ + "static/media/img15.6ead61e6.jpg";